import { render, staticRenderFns } from "./cover-note.vue?vue&type=template&id=9420640c&scoped=true&"
import script from "./cover-note.vue?vue&type=script&lang=js&"
export * from "./cover-note.vue?vue&type=script&lang=js&"
import style0 from "./cover-note.vue?vue&type=style&index=0&id=9420640c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9420640c",
  null
  
)

export default component.exports